/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Invite_MembersInputs */

const en_community_invite_members = /** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const id_community_invite_members = /** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota`)
};

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const es_community_invite_members = en_community_invite_members;

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const fr_community_invite_members = en_community_invite_members;

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const de_community_invite_members = en_community_invite_members;

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const ja_community_invite_members = en_community_invite_members;

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const zh_community_invite_members = en_community_invite_members;

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const ar_community_invite_members = en_community_invite_members;

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const it_community_invite_members = en_community_invite_members;

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const ru_community_invite_members = en_community_invite_members;

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const pt_community_invite_members = en_community_invite_members;

/** @type {(inputs: Community_Invite_MembersInputs) => LocalizedString} */
const ko_community_invite_members = en_community_invite_members;

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Community_Invite_MembersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_invite_members = /** @type {((inputs?: Community_Invite_MembersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Invite_MembersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_invite_members(inputs)
	if (locale === "es") return es_community_invite_members(inputs)
	if (locale === "fr") return fr_community_invite_members(inputs)
	if (locale === "de") return de_community_invite_members(inputs)
	if (locale === "ja") return ja_community_invite_members(inputs)
	if (locale === "zh") return zh_community_invite_members(inputs)
	if (locale === "ar") return ar_community_invite_members(inputs)
	if (locale === "id") return id_community_invite_members(inputs)
	if (locale === "it") return it_community_invite_members(inputs)
	if (locale === "ru") return ru_community_invite_members(inputs)
	if (locale === "pt") return pt_community_invite_members(inputs)
	return ko_community_invite_members(inputs)
});